export default __webpack_public_path__ + "static/CEL-0dd50f3834a93f71049b4718915a9cb6.png";